import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { clearGameImages, fetchGameImages, updateGameImages, INSTANT_GAME_TYPE } from 'app/actions/game-images.actions';
import { initGrid } from 'utils/grid/grid';
import template from './games-tab.html';

const mapStateToThis = ({ session, dictionary, dirtyForms, gameImages, ui, config }) => {
  const { locale } = session;
  const terms = dictionary.terms[locale];
  const { isLoading, isSaving, games, newImages } = gameImages;
  const { pagination } = ui;
  const { defaultPageNo, defaultPageSizes, sortColumnKey, pageSizeKey, directionKey } = config;

  return {
    dirtyForms,
    terms,
    games,
    newImages,
    isLoading,
    isSaving,
    pagination,
    defaultPageNo,
    pageSizeKey,
    sortColumnKey,
    directionKey,
    defaultPageSize: defaultPageSizes[2],
    numberOfGameImagesToSave: newImages.length,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  fetchGameImages,
  clearGameImages,
  updateGameImages,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'Notifications')
class GamesTabController {
  constructor() {
    this.DIRTY_FORM = this.type;
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    if (this.type === INSTANT_GAME_TYPE) {
      this.defaultParams = {
        [this.sortColumnKey]: 'launchDate',
        [this.directionKey]: false,
        [this.pageSizeKey]: this.defaultPageSize,
      };
    } else {
      this.defaultParams = {
        [this.sortColumnKey]: 'gameNumber',
        [this.directionKey]: true,
        [this.pageSizeKey]: this.defaultPageSize,
      };
    }
    this.gridModel = initGrid(this.fetchGameImages, this.defaultParams);
    this.gridModel.pagingModel.filters.type = this.type;
    this.gridModel.applyFilters();
    this.showInfo = true;
    this.missingImageFilter = this.getMissingImageOptions();
  }

  $onDestroy() {
    this.clearGameImages();
    this.unsubscribe();
  }

  closeInfo() {
    this.showInfo = false;
  }

  isDirtyForm() {
    return this.dirtyForms[this.DIRTY_FORM];
  }

  onFileChanged() {
    this.setDirtyForm(this.DIRTY_FORM, true);
  }

  getMissingImageOptions() {
    return [
      {
        id: undefined,
        label: this.gettextCatalog.getString('Show all'),
      },
      {
        id: true,
        label: this.gettextCatalog.getString('Without logo'),
      },
      {
        id: false,
        label: this.gettextCatalog.getString('With logo'),
      },
    ];
  }

  applyFilters() {
    if (this.filtersForm.$invalid) {
      return;
    }
    this.gridModel.pagingModel.filters.type = this.type;
    this.gridModel.applyFilters();
  }

  cancel() {
    this.setDirtyForm(this.DIRTY_FORM, false);
    this.showSuccessCancelNotification();
    return this.clearGameImages();
  }

  showStartSavingNotification() {
    this.Notifications.customNotification(
      {
        message: this.gettextCatalog.getString('Saving {{ numberOfGameImagesToSave }} images...', {
          numberOfGameImagesToSave: this.numberOfGameImagesToSave,
        }),
        timeOut: 0,
      },
      'toast',
      'info'
    );
  }

  showSuccessSavingNotification() {
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Game images saved successfully.'));
  }

  showErrorSavingNotification() {
    this.Notifications.alertError(
      this.gettextCatalog.getString('Error while saving {{ numberOfGameImagesToSave }} images', {
        numberOfGameImagesToSave: this.numberOfGameImagesToSave,
      })
    );
  }

  showSuccessCancelNotification() {
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been canceled.'));
  }

  clearFilters() {
    this.gridModel = initGrid(this.fetchGameImages, this.defaultParams);
    return this.applyFilters();
  }

  async save() {
    this.showStartSavingNotification();

    const imageIds = this.newImages.map(newImage => newImage.gameId);

    for (let i = 0; i < imageIds.length; i++) {
      await this.updateGameImages(this.type, this.newImages.find(newImage => newImage.gameId === imageIds[i]));
    }

    this.Notifications.clear();
    if (this.numberOfGameImagesToSave === 0) {
      this.setDirtyForm(this.DIRTY_FORM, false);
      this.showSuccessSavingNotification();
    } else {
      this.showErrorSavingNotification();
    }
  }
}

export default class GamesTabComponent {
  constructor() {
    this.controller = GamesTabController;
    this.template = template;
    this.bindings = {
      type: '<',
      acceptFileFormat: '<',
      acceptFileDimensions: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/game-images/components/games-tab/games-tab-component.js